import React from 'react';
import { Grid, Typography, Link, Button } from '@mui/material';
import { Image } from 'mui-image';

export default function Cottey() {
  return (
    <Grid>
      <Grid item xs={12} textAlign="center">
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Cottey College
        </Typography>
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Typography variant="h5" padding>
          Supported by Women for Women
        </Typography>
      </Grid>
      <Grid item xs={1} />
      <Grid item xs={10}>
        <Typography variant="body1" padding>
          Cottey College, a nationally ranked, fully accredited, independent,
          liberal arts and sciences college for women located in Nevada,
          Missouri, has been supported by P.E.O. since 1927 and offers
          baccalaureate degrees in a variety of majors. Cottey College, a
          debt-free institution, welcomes women from around the world.
        </Typography>
      </Grid>
      <Grid item xs={1} />
      <Grid
        item
        container
        xs={12}
        justifyContent="center"
        alignItems="center"
        direction="column"
      >
        <Image
          src={
            'https://www.peointernational.org/wp-content/uploads/bb-plugin/cache/Cottey-College-Main-Hall-panorama-6ececbbc062dd8b91404ad08de25271f-8eun14fthm2v.jpg'
          }
          alt="Cottey College"
          sx={{ maxWidth: '700px', borderRadius: 2 }}
          width={'60vw'}
        />
      </Grid>
      <Grid item xs={12} textAlign="center" padding paddingTop={4}>
        <Link href="https://www.cottey.edu/" target="_blank" rel="noopener">
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 'bold' }}
          >
            Visit Cottey College
          </Button>
        </Link>
      </Grid>
    </Grid>
  );
}
